import React, { useMemo } from 'react'
import AsyncDropdown, { PropsWithAsyncDropdown } from 'core/elements/dropdown/AsyncDropdown'

interface Props {
  domains: string[]
}

export default function DomainPicklist({
  name = 'domain',
  label = 'Domain',
  compact = false,
  domains = [],
  ...rest
}: PropsWithAsyncDropdown<Props>) {
  const options = useMemo(() => {
    return domains.map((domain) => ({
      label: domain,
      value: domain,
    }))
  }, [domains])

  return <AsyncDropdown compact={compact} name={name} label={label} items={options} {...rest} />
}
